import React, { FC } from 'react';

import {
  makeStyles, Button, Box, Typography, List, TextField, ListItem,
} from '@material-ui/core';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';

const useStyles = makeStyles({
  label: {
    width: '8rem',
  },
  textField: {
    width: '10rem',
  },
});

interface BasicEditorFormProps {
  name: string,
  label: string,
  coverPageUrl: string
}

const schema = yup.object().shape({
  name: yup.string().required(),
  label: yup.string().required(),
  coverPageUrl: yup.string().required(),
});

interface BasicsEditorProps {
  catalogSpec: any,
  onUpdate: (name: string, label: string, coverPageUrl: string) => void,
}

const BasicsEditor: FC<BasicsEditorProps> = (props) => {
  const { catalogSpec, onUpdate } = props;
  const { handleSubmit, register, errors } = useForm<BasicEditorFormProps>({
    validationSchema: schema,
  });
  const classes = useStyles();

  const onSubmit = (values: any) => {
    onUpdate(values.name, values.label, values.coverPageUrl);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <List>
        <ListItem>
          <Typography className={classes.label}>Name</Typography>
          <TextField
            required
            id="name"
            name="name"
            defaultValue={catalogSpec.name}
            className={classes.textField}
            inputRef={register}
          />
          {errors.name && <Typography>{errors.name}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>Label</Typography>
          <TextField
            required
            id="label"
            name="label"
            defaultValue={catalogSpec.label}
            className={classes.textField}
            inputRef={register}
          />
          {errors.label && <Typography>{errors.label}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>Cover Page Url</Typography>
          <TextField
            required
            id="coverpageurl"
            name="coverpageurl"
            defaultValue={catalogSpec.coverPageUrl}
            className={classes.textField}
            inputRef={register}
          />
          {errors.coverPageUrl && <Typography>{errors.coverPageUrl}</Typography>}
        </ListItem>
      </List>
      <Box style={{ textAlign: 'left', paddingTop: '2rem' }}>
        <Button type="submit"><Typography variant="h6">Update</Typography></Button>
      </Box>
    </form>
  );
};

export default BasicsEditor;
